import { Field, FieldAttributes, FormikErrors, FormikTouched } from "formik"
import { ComponentProps, ReactElement, useState } from "react";
import MultipleSelectBoxApiCall from "src/components/Common/UI/MultipleSelectBox/MultipleSelectBoxApiCall";
import MultipleSelectBoxFormik from "src/components/Common/UI/MultipleSelectBox/MultipleSelectBoxFormik";


export const StyledInputText = <T,>({
  name,
  label,
  errors,
  touched,
}: StyledInputTextProps<T>): ReactElement   => {
  return (
    <>
      <div className="flex-grow-1">
        <label className="form-label">{label}</label>
      </div>
      <div className="mb-3">
        <Field
          name={name}
          label={label}
          className="form-control"
          placeholder=""
          type="text"
        />
        <div className="text-danger">
        {errors[name as keyof T] && touched[name as keyof T] ? (
          <div>{(errors[name as keyof T] as string)}</div>
        ) : null}
        </div>
      </div>
    </>
  )
}

export const StyledInputSearch = <T,>({
  label,
  errorName,
  errors,
  touched,
  ...props
}: StyledInputSearchProps<T>): ReactElement   => {
  return (
    <>
      <div className="flex-grow-1">
        <label className="form-label">{label}</label>
      </div>
      <div className="mb-3">
        <MultipleSelectBoxApiCall
          {...props}
        />
        <div className="text-danger">
          {errors[errorName as keyof T] && touched[errorName as keyof T] ? (
            <div>{(errors[errorName as keyof T] as string)}</div>
          ) : null}
        </div>
      </div>
    </>
  )
}

export const StyledInputSearchFormik = <T,>({
  label,
  errorName,
 /*  errors,
  touched, */
  ...props
}: StyledInputSearchFormikProps<T>): ReactElement   => {
  return (
    <>
      <div className="flex-grow-1">
        <label className="form-label">{label}</label>
      </div>
      <div className="mb-3">
        <MultipleSelectBoxFormik
         {...props}        />
       {/*  <div className="text-danger">
          {errors[errorName as keyof T] && touched[errorName as keyof T] ? (
            <div>{(errors[errorName as keyof T] as string)}</div>
          ) : null}
        </div> */}
      </div>
    </>
  )
}

type StyledInputSearchProps<T> = {
  label: string;
  errorName: string;
  errors: FormikErrors<T>;
  touched: FormikTouched<T>;
} & ComponentProps<typeof MultipleSelectBoxApiCall>

type StyledInputSearchFormikProps<T> = {
  label: string;
  errorName: string;
 /*  errors: FormikErrors<T>;
  touched: FormikTouched<T>; */
} & ComponentProps<typeof MultipleSelectBoxFormik>

type StyledInputTextProps<T> = {
  label: string;
  name: string;
  errors: FormikErrors<T>;
  touched: FormikTouched<T>;
};
